<template>
    <div id="Console">
        <el-card shadow = "never">
            <el-row>
                <el-col :span="20" :offset="1">
                    <el-form
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="80px"
                    class="demo-ruleForm"
                    >
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-select v-model="value" filterable placeholder="试一试搜索:销售地点" :clearable = 'clearable'  :loading="loading2" @change="handleChange2" size = "large" style="width : 350px" :disabled = "disabled">
                                <i class="el-icon-loading" slot = "prefix" v-if='isLoading'></i>
                                <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <p class="tip"><span>*</span>{{locNullTip}}</p>
                        </el-form-item>
                        <el-form-item label="类型" prop="typeCode">
                            <el-select v-model="value3" placeholder="请选择类型" clearable @change="handleChange3" size = "large"  style="width : 350px">
                                <el-option
                                    v-for="item in options3"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <p class="tip"><span>*</span>{{typeNullTip}}</p>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                            <el-button @click="downLoad2('库存详情')" type="success">下载表格</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        max-height="340"
                        :data = "tableData"
                        :summary-method="getSummaries"  
                        show-summary
                        border
                        style="width:100%"
                    >
                        <el-table-column
                            prop="locationName"
                            label="地点"
                            header-align="center"
                            align="left"
                            min-width="150"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="typeName"
                            label="类型"
                            header-align="center"
                            align="left"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="onhandQuantity"
                            label="收货数量"
                             header-align="center"
                             align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="saleQty"
                            label="销售数量"
                             header-align="center"
                             align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="redeemQty"
                            label="核销数量"
                             header-align="center"
                             align="right"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="onQty"
                            label="库存数量"
                            header-align="center"
                            align="right"
                            >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
@import '~@/assets/css/common';
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
// import axios from '../../env/axios'
// import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        return {
            ruleForm:{
                locationCode:'',
                typeCode : ''
            },
            defaultVal :[],
            rules:{
                
            },
            options2:[
                {
                    value : '', 
                    label : ''
                }
            ],
            value: '',
            labelPosition: 'right',
            tableData:[
                
            ],
            loading: false,
            spanArr: [],
            clearable : false,
            disabled : true ,
            options3 :[
                {
                    value : '',
                    label : ''
                }
            ],
            value3 : '',
            loading2 : false ,
            input5: '',
            isLoading:true
        }
    },
    created (){
    },
    mounted(){
        this.loadingArea().then((res) => {
            this.options2 = res;
            this.getLoc();
            this.loadType() ;
        }); 
       
    },
    methods:{
        //下载表格
        downLoad2(name){
            this.isDownTable(this.tableData, this.downLoad ,name);
        },
        
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { locationCode, typeCode } = this.ruleForm ;
                    let userId = sessionStorage.getItem("userId") ;
                    let params ;
                    this.tableData = [] ;
                    // console.log(this.ruleForm)
                    if(!locationCode && !typeCode){
                        params = {
                            act : 'repertoryDetail',
                            userId
                        }
                    }else if(locationCode && !typeCode){
                        params = {
                            act : 'repertoryDetail',
                            locationCode,
                            userId
                        }
                    }else if(!locationCode && typeCode){
                         params = {
                            act : 'repertoryDetail',
                            typeCode,
                            userId
                        }
                    }else if(locationCode && typeCode){
                        params = {
                            act : 'repertoryDetail',
                            typeCode,
                            locationCode,
                            userId
                        }
                    }
                    this.reportoryDetail(params)
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        handleChange2(value){
            this.ruleForm.locationCode = value ;
            this.tableData = [];
        },
        handleChange3(val){
            this.ruleForm.typeCode = val ;
            this.tableData = [];
        },
        //默认显示用户地点/获取地点编号
        getLoc(){
            this.getUserLocation().then((res) => {
                let userId = sessionStorage.getItem("userId") ;
                let userLevel = sessionStorage.getItem("userLevel") ;
                this.value = res ;
                this.ruleForm.locationCode = res;
                this.isLoading = false ;
                if(userId == "SHFD01" || userId == "HBFD01" || userId == 'HNFD01' || userId == 'JENNIE' || userId == 'SYSADMIN'){
                    this.clearable = true ;
                    this.disabled = false ;
                }else if(userLevel == 'A'){
                    this.clearable = true ;
                    this.disabled = false ;
                }else{
                    // console.log('不是财务账号')
                    this.clearable = false ;
                    this.disabled = true ;
                }
            })
        },
        //查找类型
        loadType(){
            let params = {
                act : 'findTypes',
                userId: sessionStorage.getItem('userId')
            }
            this.findType(params).then((res) => {
                let { status,list } = res.data ;
                if(status){
                    this.options3 = list.map(elem => {
                        return {value : elem.typeCode ,label :elem.description}
                    }) ;
                }else{
                    // this.promptMsg('加载失败' ,'info')
                }
            })
        },
        //加载表格
        reportoryDetail(params){
            let that = this ;
            that.delType(params).then((res) => {
                that.loading = true ;
                let { status } = res.data ;
                if(status == true){
                    let { report } = res.data ;
                    report.forEach((elem) => {
                        elem.onhandQuantity = that.changeTree(Math.trunc(elem.onhandQuantity))  
                        elem.saleQty = that.changeTree(Math.trunc(elem.saleQty))
                        elem.onQty = that.changeTree(Math.trunc(elem.onQty))
                        elem.redeemQty = that.changeTree(Math.trunc(elem.redeemQty))
                    })
                    that.loading = false ;
                    that.tableData = report ;
                }else{
                    that.loading = false ;
                    // that.alert('加载失败!','warning')
                }
            })
        },
        //总计最后一行
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item =>{
                    // console.log(typeof item[column.property] )
                    return Number(item[column.property].replace(/,/g, ""))
                    
                    });

                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    // sums[index]
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
            return sums;
        },
    }
}
</script>
